(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("enquiry-box", [], factory);
	else if(typeof exports === 'object')
		exports["enquiry-box"] = factory();
	else
		root["enquiry-box"] = factory();
})(window, function() {
return 